import { setArableEnvironment } from '@next/arable-lib/shared';
import { Environment } from './environment.model';

export { Environment } from './environment.model';

const AZURE_MAPS_SUBSCRIPTION_KEY = 'IHcXzbzitb0qs1sHQuoiQcuGyOVqmoaMmzyev2Keq-k';

const baseEnvironment = setArableEnvironment({
  APPLICATION_NAME: 'NextAdmin',
  API_BASE_URL: 'https://next-admin.agrifirm.com',
  CLIENT_ID: '8c830f86-9b7a-4d6b-a6bb-140b5ffcbd9b',
  REDIRECT_URL: 'https://next-admin.agrifirm.com',
  APIM_BASE_URL: 'https://gateway.api.agrifirm.com/external',
  LOGIN_TYPE: 'redirect',
  SIGNUP_SIGNIN_POLICY: 'B2C_1A_AllAccountsSignupSignin',
  PASSWORD_RESET_POLICY: 'B2C_1A_PasswordReset',
  AUTHORITY: 'https://agrifirmb2c.b2clogin.com/tfp/agrifirmb2c.onmicrosoft.com/',
  APPLICATION_KEY: 'NextAdmin',
  AUTHORIZED_BY: 'NextAdmin|Administrator|GlobalAdministrator',
  APP_INSIGHTS_KEY: 'aaac3537-49ba-4259-8e8c-e7716f3902e9',
  DEFAULT_LOCALE: 'nl-NL',
  LOCALES: 'nl-NL,en-US',
  PRODUCTION: 'true',
  KUBE_NODE_NAME: 'local-node',
  KUBE_POD_NAME: 'local-pod',
  KUBE_TEAM: 'platform',
  AZURE_MAPS_SUBSCRIPTION_KEY,
  PRE_SALES_REBUILD_DONE: 'false',
  FIELD_ADVICE_TEMPLATE_REBUILD_DONE: 'true',
});

export const environment: Environment = {
  ...baseEnvironment,
  AZURE_MAPS_SUBSCRIPTION_KEY,
  PRE_SALES_REBUILD_DONE: false,
  FIELD_ADVICE_TEMPLATE_REBUILD_DONE: true,
};
